/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdresseDto } from './AdresseDto';
import {
    AdresseDtoFromJSON,
    AdresseDtoFromJSONTyped,
    AdresseDtoToJSON,
} from './AdresseDto';
import type { CompteBancaireDto } from './CompteBancaireDto';
import {
    CompteBancaireDtoFromJSON,
    CompteBancaireDtoFromJSONTyped,
    CompteBancaireDtoToJSON,
} from './CompteBancaireDto';

/**
 * 
 * @export
 * @interface FcbApprenantDoublonGridDto
 */
export interface FcbApprenantDoublonGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantDoublonGridDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isProspect?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbApprenantDoublonGridDto
     */
    idsSocieteExterne?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantDoublonGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {AdresseDto}
     * @memberof FcbApprenantDoublonGridDto
     */
    adresseDto?: AdresseDto;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    readonly adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    readonly codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    readonly localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    codePaysNaissance?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbApprenantDoublonGridDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    numeroIdentification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {CompteBancaireDto}
     * @memberof FcbApprenantDoublonGridDto
     */
    compteBancaire?: CompteBancaireDto;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    beid?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    beidnumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbApprenantDoublonGridDto
     */
    dateDeces?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    localiteNaissance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbApprenantDoublonGridDto
     */
    communeNaissance?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isApprenant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isFormateur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isRepresentant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isTuteur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isChefEntreprise?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isCollaborateur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isDelegueTutelle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isConseillePedagogique?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FcbApprenantDoublonGridDto
     */
    isContact?: boolean;
}

/**
 * Check if a given object implements the FcbApprenantDoublonGridDto interface.
 */
export function instanceOfFcbApprenantDoublonGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantDoublonGridDtoFromJSON(json: any): FcbApprenantDoublonGridDto {
    return FcbApprenantDoublonGridDtoFromJSONTyped(json, false);
}

export function FcbApprenantDoublonGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantDoublonGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'isProspect': !exists(json, 'isProspect') ? undefined : json['isProspect'],
        'idsSocieteExterne': !exists(json, 'idsSocieteExterne') ? undefined : json['idsSocieteExterne'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'adresseDto': !exists(json, 'adresseDto') ? undefined : AdresseDtoFromJSON(json['adresseDto']),
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codePaysNaissance': !exists(json, 'codePaysNaissance') ? undefined : json['codePaysNaissance'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'numeroIdentification': !exists(json, 'numeroIdentification') ? undefined : json['numeroIdentification'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'compteBancaire': !exists(json, 'compteBancaire') ? undefined : CompteBancaireDtoFromJSON(json['compteBancaire']),
        'beid': !exists(json, 'beid') ? undefined : json['beid'],
        'beidnumber': !exists(json, 'beidnumber') ? undefined : json['beidnumber'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'dateDeces': !exists(json, 'dateDeces') ? undefined : (json['dateDeces'] === null ? null : new Date(json['dateDeces'])),
        'localiteNaissance': !exists(json, 'localiteNaissance') ? undefined : json['localiteNaissance'],
        'communeNaissance': !exists(json, 'communeNaissance') ? undefined : json['communeNaissance'],
        'isApprenant': !exists(json, 'isApprenant') ? undefined : json['isApprenant'],
        'isFormateur': !exists(json, 'isFormateur') ? undefined : json['isFormateur'],
        'isRepresentant': !exists(json, 'isRepresentant') ? undefined : json['isRepresentant'],
        'isTuteur': !exists(json, 'isTuteur') ? undefined : json['isTuteur'],
        'isChefEntreprise': !exists(json, 'isChefEntreprise') ? undefined : json['isChefEntreprise'],
        'isCollaborateur': !exists(json, 'isCollaborateur') ? undefined : json['isCollaborateur'],
        'isDelegueTutelle': !exists(json, 'isDelegueTutelle') ? undefined : json['isDelegueTutelle'],
        'isConseillePedagogique': !exists(json, 'isConseillePedagogique') ? undefined : json['isConseillePedagogique'],
        'isContact': !exists(json, 'isContact') ? undefined : json['isContact'],
    };
}

export function FcbApprenantDoublonGridDtoToJSON(value?: FcbApprenantDoublonGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'isProspect': value.isProspect,
        'idsSocieteExterne': value.idsSocieteExterne,
        'idpersonne': value.idpersonne,
        'nom': value.nom,
        'prenom': value.prenom,
        'adresseDto': AdresseDtoToJSON(value.adresseDto),
        'nationalite': value.nationalite,
        'codePaysNaissance': value.codePaysNaissance,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'registreNational': value.registreNational,
        'numeroIdentification': value.numeroIdentification,
        'codesexe': value.codesexe,
        'compteBancaire': CompteBancaireDtoToJSON(value.compteBancaire),
        'beid': value.beid,
        'beidnumber': value.beidnumber,
        'remarque': value.remarque,
        'dateDeces': value.dateDeces === undefined ? undefined : (value.dateDeces === null ? null : value.dateDeces.toISOString()),
        'localiteNaissance': value.localiteNaissance,
        'communeNaissance': value.communeNaissance,
        'isApprenant': value.isApprenant,
        'isFormateur': value.isFormateur,
        'isRepresentant': value.isRepresentant,
        'isTuteur': value.isTuteur,
        'isChefEntreprise': value.isChefEntreprise,
        'isCollaborateur': value.isCollaborateur,
        'isDelegueTutelle': value.isDelegueTutelle,
        'isConseillePedagogique': value.isConseillePedagogique,
        'isContact': value.isContact,
    };
}

